import { pct } from "../lib/calc";
import { cleanPrintLabel } from "../lib/printLabel";
import type { MarketProduct } from "../types";

type Props = {
  pick: MarketProduct;
  asAt: string;
  quotedLvr: number;
  showComparison: boolean;
};

function verifiedLabel(iso: string | undefined, fallback: string): string {
  if (!iso) return fallback;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
}

export function PrintProvenance({ pick, asAt, quotedLvr, showComparison }: Props) {
  const when = verifiedLabel(pick.verifiedAt, asAt);
  const cdr = pick.sourceKind === "cdr" || pick.reviewStatus === "VERIFIED_WITH_CDR";
  const product = cleanPrintLabel(pick.product);
  return (
    <p className="cite">
      <span>
        {product} · quoted at {quotedLvr}% LVR
        {showComparison ? ` · comparison ${pct(pick.comparisonRate)}` : ""}
        {` · as at ${when}`}
      </span>
      {pick.ratesUrl ? (
        <>
          {" "}
          <a href={pick.ratesUrl} target="_blank" rel="noreferrer noopener">
            {pick.lender} rates page
          </a>
        </>
      ) : null}
      <small>
        Advertised new-customer print, not a personal offer.
        {cdr ? " Cross-checked with the lender’s Consumer Data Right feed." : " Confirm on the lender page before you call."}
      </small>
    </p>
  );
}
